import {
  BaseFieldFilter,
  NativeFieldFilter,
  Operation,
} from 'module/api/filter/types';
import { unreachable } from 'module/helpers/unreachable';
import { SingleSelectField } from 'module/types/filter-field/field/filterable-field';
import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { SingleSelectFieldFilter } from 'module/types/filter-field/filter/single-select';
import { fromApiValue, toType } from './select';

const toApiFormat = (filter: SingleSelectFieldFilter): BaseFieldFilter => {
  switch (filter.type) {
    case SelectFilterOperationType.IsEmpty:
      return {
        operation: Operation.IsEmpty,
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsNotEmpty:
      return {
        operation: Operation.IsNotEmpty,
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.Is:
      return {
        operation: Operation.Value,
        value: filter.value == null ? '' : String(filter.value),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsNot:
      return {
        operation: Operation.IsNot,
        value: filter.value == null ? '' : String(filter.value),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsAtLeast:
      return {
        operation: Operation.GreaterThanEqual,
        value: filter.value == null ? '' : String(filter.value),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsAtMost:
      return {
        operation: Operation.LessThanEqual,
        value: filter.value == null ? '' : String(filter.value),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsNoneOf:
      return {
        operation: Operation.NoneOf,
        value: filter.value == null ? '' : filter.value.join(','),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsOneOf:
      return {
        operation: Operation.OneOf,
        value: filter.value == null ? '' : filter.value.join(','),
        sourceType: filter.field.sourceType,
      };
    default:
      return unreachable(filter);
  }
};

const parse = (
  { value, operation }: NativeFieldFilter,
  field: SingleSelectField,
): SingleSelectFieldFilter => {
  const type = toType(operation);

  switch (type) {
    case SelectFilterOperationType.IsEmpty:
    case SelectFilterOperationType.IsNotEmpty:
      return { field, type };
    case SelectFilterOperationType.Is:
    case SelectFilterOperationType.IsNot:
    case SelectFilterOperationType.IsAtLeast:
    case SelectFilterOperationType.IsAtMost:
      return { field, type, value: (fromApiValue(value ?? '') ?? [])[0] };
    case SelectFilterOperationType.IsOneOf:
    case SelectFilterOperationType.IsNoneOf:
      return { field, type, value: fromApiValue(value ?? '') ?? [] };
    default:
      return unreachable(type);
  }
};

export const SingleSelectFilter = {
  parse,
  toApiFormat,
  from: fromApiValue,
};
